
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  locale: string
};

/**
 * Export `fetchAllCollections`.
 */

export async function fetchAllCollections({ locale }: Query) {
  const endpoint = getApiEndpoint('getCollections');

  try {
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale),
      params: { mode: 'all' }
    });

    return data?.data;
  } catch (error) {
    handleRequestError(error);
  }
}
